(() => {
  const enhanced = new WeakSet();

  function activate(root, key, focus = false) {
    const selected = root.querySelector(`[data-pdp-tab="${key}"]`);
    if (!selected) return;
    root.querySelectorAll('[data-pdp-tab]').forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-pdp-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.pdpPanel !== key;
    });
    if (focus) selected.focus();
  }

  function reveal(target, scroll = false) {
    const panel = target?.closest('[data-pdp-panel]');
    const root = panel?.closest('[data-pdp-details]');
    if (!root || !enhanced.has(root)) return false;
    activate(root, panel.dataset.pdpPanel);
    if (scroll) {
      panel.focus({ preventScroll: true });
      root.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    return true;
  }

  function hashTarget() {
    if (!location.hash) return null;
    return document.getElementById(location.hash.slice(1));
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-pdp-details]').forEach((root) => {
      if (enhanced.has(root)) return;
      const nav = root.querySelector('[data-pdp-tabs]');
      const tabs = [...root.querySelectorAll('[data-pdp-tab]')];
      if (!nav || !tabs.length) return;
      enhanced.add(root);
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', root.getAttribute('aria-label'));
      tabs.forEach((tab) => {
        tab.setAttribute('role', 'tab');
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
      });
      root.dataset.pdpEnhanced = '';
      activate(root, tabs[0].dataset.pdpTab);
      nav.hidden = false;
      nav.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-pdp-tab]');
        if (tab) activate(root, tab.dataset.pdpTab);
      });
      nav.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(event.target.closest('[data-pdp-tab]'));
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(root, tabs[next].dataset.pdpTab, true);
      });
    });
    reveal(hashTarget());
  }

  document.addEventListener('click', (event) => {
    const detailsLink = event.target.closest('[data-pdp-details-link]');
    if (detailsLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const target = document.getElementById(detailsLink.hash.slice(1));
      if (reveal(target, true)) event.preventDefault();
    }
    const opener = event.target.closest('[data-mo-pdp-dialog-open]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const dialog = document.getElementById(opener.dataset.moPdpDialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
    }
    const closer = event.target.closest('[data-mo-pdp-dialog-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.mo-pdp-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  window.addEventListener('hashchange', () => reveal(hashTarget(), true));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
